import { useMemo, useRef } from 'react';
export const createContainer = containerStyle => {
  const container = window.document.createElement('div');
  Object.assign(container.style, containerStyle);
  return container;
};
export const useElementRef = containerStyle => {
  const element = useMemo(() => createContainer(containerStyle), [containerStyle]);
  return useRef(element);
};
export const popoverRectForPosition = (placement, childRect, popoverRect, padding) => {
  const targetMidX = childRect.left + childRect.width / 2;
  const targetMidY = childRect.top + childRect.height / 2;
  const {
    width,
    height
  } = popoverRect;
  let top;
  let left;
  const [position, alignment] = placement.split(' ');
  switch (position) {
    case 'left':
      top = targetMidY - height / 2;
      left = childRect.left - padding - width;
      if (alignment === 'top') {
        top = childRect.top;
      }
      if (alignment === 'bottom') {
        top = childRect.bottom - height;
      }
      break;
    case 'bottom':
      top = childRect.bottom + padding;
      left = targetMidX - width / 2;
      if (alignment === 'left') {
        left = childRect.left;
      }
      if (alignment === 'right') {
        left = childRect.right - width;
      }
      break;
    case 'right':
      top = targetMidY - height / 2;
      left = childRect.right + padding;
      if (alignment === 'top') {
        top = childRect.top;
      }
      if (alignment === 'bottom') {
        top = childRect.bottom - height;
      }
      break;
    default:
      top = childRect.top - height - padding;
      left = targetMidX - width / 2;
      if (alignment === 'left') {
        left = childRect.left;
      }
      if (alignment === 'right') {
        left = childRect.right - width;
      }
      break;
  }
  return {
    top,
    left,
    width,
    height,
    right: left + width,
    bottom: top + height
  };
};
export const rectsAreEqual = (rectA, rectB) => rectA === rectB || rectA.bottom === rectB.bottom && rectA.height === rectB.height && rectA.left === rectB.left && rectA.right === rectB.right && rectA.top === rectB.top && rectA.width === rectB.width;
export const nudgePopoverRectIfNeeded = ({
  popoverRect,
  boundaryRect,
  boundaryInset
}) => {
  const topBoundary = boundaryRect.top + boundaryInset;
  const leftBoundary = boundaryRect.left + boundaryInset;
  const rightBoundary = boundaryRect.right - boundaryInset;
  const bottomBoundary = boundaryRect.bottom - boundaryInset;
  let top = popoverRect.top < topBoundary ? topBoundary : popoverRect.top;
  top = top + popoverRect.height > bottomBoundary ? bottomBoundary - popoverRect.height : top;
  if (boundaryRect.height <= popoverRect.height) {
    top = popoverRect.top;
  }
  let left = popoverRect.left < leftBoundary ? leftBoundary : popoverRect.left;
  left = left + popoverRect.width > rightBoundary ? rightBoundary - popoverRect.width : left;
  return {
    top,
    left,
    width: popoverRect.width,
    height: popoverRect.height,
    right: left + popoverRect.width,
    bottom: top + popoverRect.height
  };
};